import { WageringConditionBonus } from 'config/types/bonus/userBonus'
import React from 'react'

import { WageringBonusStatusEnums } from 'config/types/bonus'
import DepositBonusContent from './DepositBonusContent'
import InWageringProcess from './InWageringProcess'
import MakeSpinBonusContent from './MakeSpinBonusContent'

interface BonusItemProps {
  bonus: WageringConditionBonus
}

const WageringBonusContent: React.FC<BonusItemProps> = ({ bonus }) => {
  if (bonus.wageringBonusStatus === WageringBonusStatusEnums.WaitingSpin) {
    return <MakeSpinBonusContent bonus={bonus} />
  }

  if (bonus.wageringBonusStatus === WageringBonusStatusEnums.WaitingDeposit) {
    return <DepositBonusContent bonus={bonus} />
  }

  if (bonus.wageringBonusStatus === WageringBonusStatusEnums.InProgressWagering) {
    return <InWageringProcess bonus={bonus} />
  }
}

export default WageringBonusContent
